import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styles from "./NavBar.module.css"
import AccordionNav from "./AccordionNav"

const NavBar = ({ user, handleLogout, handleStopImpersonation }) => {

    const [accordionData, setAccordionData] = useState([])
    const location = useLocation()
    const BuildAccordion = () => {
        let accordionDataMain = user && user.Role === "SuperAdmin" ?
            [
                {
                    "contentheader": "Home",
                    "contentdescription": "Return to main page",
                    "contentlink": "/Index"
                },
                {
                    "contentheader": "ELMAH",
                    "contentdescription": "Review elmah logs",
                    "contentlink": "/elmah"
                },
                {
                    "contentheader": "Account",
                    "contentdescription": "Alter account details",
                    "contentlink": "/ManageAccount"
                },

                {
                    "contentheader": "Contact Us",
                    "contentdescription": "Contact site staff",
                    "contentlink": "/Contact"
                },

            ]
            : user && user.Role ? // Admin, Exhibitor
                [
                    {
                        "contentheader": "Home",
                        "contentdescription": "Return to main page",
                        "contentlink": "/Index"
                    },
                    {
                        "contentheader": "Account",
                        "contentdescription": "Alter account details",
                        "contentlink": "/ManageAccount"
                    },

                    {
                        "contentheader": "Contact Us",
                        "contentdescription": "Contact site staff",
                        "contentlink": "/Contact"
                    },
                ]
                : [
                    {
                        "contentheader": "Log In",
                        "contentdescription": "Site login",
                        "contentlink": "/Login"
                    },
                    {
                        "contentheader": "Contact Form",
                        "contentdescription": "Contact site staff",
                        "contentlink": "/Contact"
                    },

                ]
        // default
        if (accordionDataMain) {
            setAccordionData(accordionDataMain)
        }
        else {
            setAccordionData(null)
        }
    }
    useEffect(() => {
        // try to force rebuild
        // meant to fix initial login issue where the navbar was showing up empty
        BuildAccordion()
    }, [user])
    useEffect(() => {
        // try to force rebuild
        // meant to fix initial login issue where the navbar was showing up empty
        BuildAccordion()
    }, [])

    return (
        <>
            {
                location && location.pathname !== '/login' && !location.pathname.toLowerCase().includes("/leadcaptureorder/") ?
                    <nav className="z-50 bg-white">
                        <ul className={styles.ulNavBar}>
                            {accordionData && accordionData.length ? accordionData.map((item, index) => (
                                <AccordionNav key={index} menuItem={item}></AccordionNav>
                            )) : <></>}
                            <> {user && user.Role ?
                                <>
                                    <li className={styles.liNavBar}>
                                        <div className={styles.accordioncontent}>
                                            <Link to="/" onClick={handleLogout} class={styles.accordionlinks}>
                                                <label className={styles.accordionlabel}>
                                                    Log Out
                                                </label>
                                            </Link>
                                        </div>
                                    </li>
                                    {user && user.Role && user.IsImpersonating && user.IsImpersonating === 'true' ?
                                        <li className={styles.liNavBar} style={{ backgroundColor: 'red', paddingLeft:'5px' }}>
                                            <div className={styles.accordioncontent}>
                                                <Link onClick={handleStopImpersonation} class={styles.accordionlinks}>
                                                <label className={styles.accordionlabel}>
                                                        Stop Impersonation
                                                </label>
                                            </Link>
                                        </div>
                                        </li>
                                        :
                                        <></>}
                                 </>
                                
                                :
                                <></>}
                            </>
                        </ul>

                    </nav>

                    : <> </>
            }
        </>

    );
}

export default NavBar